import { Component, OnInit } from '@angular/core';
import { Constants } from '@kp/shared/constants.service';
import { BrowserCheckService } from '@kp/shared/services/browser-check.service';
import { BrowserStorage, productDisplayName, TitleService } from '@kservice';

@Component({
  selector: 'kp-screen-help',
  templateUrl: './screen-help.component.html',
  styleUrls: ['./screen-help.component.scss'],
})
export class ScreenHelpComponent implements OnInit {
  private _title = 'Help';
  isUnsupported = false;
  productName = productDisplayName;
  shownBrowserList = [];
  showSupportedBrowsersModal = false;

  constructor(
    private titleService: TitleService,
    private browserStorage: BrowserStorage,
    private browserCheckService: BrowserCheckService
  ) {}

  ngOnInit() {
    this.titleService.set(this._title);

    this.shownBrowserList = Constants.shuffledBrowserArray.filter(
      (data) => (data.os.includes(this.browserCheckService.deviceInfo.os) || data.os.length === 0) && data.recommend
    );
    this.isUnsupported = this.browserStorage.getObject('unsupportedBrowser');
    this.showSupportedBrowsersModal = this.isUnsupported;
  }

  toggleUnsupportedBrowsersModal(open?: boolean, event?: Event) {
    this.showSupportedBrowsersModal = open;
    if (open) {
      (event.target as HTMLElement).blur();
    }
  }
}
